import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeAssessor } from 'src/types/shared/Challenge';

export const fetchChallengeAssessorsRequest = createAction('fetchChallengeAssessorsRequest');
export const fetchChallengeAssessorsSuccess = createAction<ChallengeAssessorsPayload>(
    'fetchChallengeAssessorsSuccess',
);
export const fetchChallengeAssessorsFailure = createAction('fetchChallengeAssessorsFailure');

export const fetchChallengeAssessors = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeAssessorsRequest());
    try {
        const { data } = await api.get<ChallengeAssessorsPayload>(
            `admin/challenges/${challengeID}/attach-assessors`,
        );
        dispatch(fetchChallengeAssessorsSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, fetchChallengeAssessorsFailure, e);
    }
};

export interface ChallengeAssessorsPayload {
    users: ChallengeAssessor[];
}
